module.exports = __webpack_public_path__ + "img/cut-01.b201b178.jpg";